import { call } from 'redux-saga/effects';
import { BasketErrorModel, DEFAULT_ERROR_TEXT } from 'models/Errors';

export function* callBasketSaga<Fn extends(...args: any[]) => any>(fn: Fn, ...args: Parameters<Fn>): Generator<any, void, any> {
    const isSagaSuccessfullyCompleted = yield call(fn, ...args);

    if (!isSagaSuccessfullyCompleted) {
        throw new BasketErrorModel(DEFAULT_ERROR_TEXT, 'Internal saga call failed', fn.toString());
    }

    return isSagaSuccessfullyCompleted;
}